import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";

@Component({
  selector: 'workshops-view',
  templateUrl: './workshops-view.pug',
})
export class WorkshopsViewComponent implements OnInit {

  public currentTab: string

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.checkParamsForTab()
  }

  clickedTab(target: string) {
    this.currentTab = target
    this.router.navigate(['workshops'], { queryParams: { tab: this.currentTab } })
  }

  checkParamsForTab() {
    this.currentTab = this.activatedRoute.snapshot.queryParams.tab || "bookings"
  }

  isActiveTab(target: string): boolean {
    return target === this.currentTab
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/workshops-view.ts